import { FabricImage, Point, StaticCanvas } from 'fabric'

const PRINT_CANVAS_WIDTH = 685
const PRINT_CANVAS_HEIGHT = 1729
const PRINT_TEMPLATE = 'blank_template_sheet_eaiqo2.jpg'
/*
*  lowerX - controls the X axis of the sleeve in the lower quadrant. The higher the number the closer it will be to the left
*  higherX - controls the X axis of the sleeve in the higher quadrant. The higher the number the closer it will be to the left
*  scale - this affects where the sleeve is places on the Y axis.
*  widthAdder - we scale each print template to the width of the canvas (see PRINT_CANVAS_WIDTH).
*  As the sleeves are slightly different we need to adjust the actual width they are being scaled by to make they align properly with the print templates
* */

const OFFSETS : {[key: string] : {lowerX:number, higherX:number, scale:number, widthAdder:number}} = {
  xs : { lowerX: 9, higherX: 11, scale: 0.726, widthAdder: 6 },
  s  : { lowerX: 19, higherX: 11, scale: 0.726, widthAdder: 4 },
  m  : { lowerX: 16, higherX: 13, scale: 0.726, widthAdder: 5 },
  l  : { lowerX: 19, higherX: 14, scale: 0.728, widthAdder: -17 },
  xl : { lowerX: 17, higherX: 13, scale: 0.727, widthAdder: -4 },
}

export async function canvasToTemplate(url: string, size: string, el: HTMLCanvasElement): Promise<string> {
  const offset = OFFSETS[size]
  const ssrProxy = 'catalog%2FZeus Assets%2FKnee Sleeves%2FCUSTOMKNEE%2F'
  const staticCanvas: StaticCanvas = new StaticCanvas(el)
  staticCanvas.setDimensions({ width: PRINT_CANVAS_WIDTH, height: PRINT_CANVAS_HEIGHT })

  const backgroundImage = await FabricImage.fromURL(`/svc_ssr/cloudinary_proxy/${ssrProxy}${PRINT_TEMPLATE}`)
  backgroundImage.set({
    left : PRINT_CANVAS_WIDTH / 2,
    top  : PRINT_CANVAS_HEIGHT / 2,
  })
  staticCanvas.backgroundImage = backgroundImage

  staticCanvas.renderAll()
  const print = await FabricImage.fromURL(url)

  print.scaleToWidth(PRINT_CANVAS_WIDTH + offset.widthAdder)
  const topCenter = (PRINT_CANVAS_HEIGHT - (PRINT_CANVAS_HEIGHT * offset.scale))
  const point = new Point((PRINT_CANVAS_WIDTH / 2) - offset.lowerX, PRINT_CANVAS_HEIGHT * offset.scale)
  print.setPositionByOrigin(point, 'center', 'center')
  staticCanvas.add(print)

  const invertPrint = await print.clone([])
  const topPoint = new Point((PRINT_CANVAS_WIDTH / 2) - offset.higherX, topCenter)
  invertPrint.flipX = true
  invertPrint.flipY = true

  invertPrint.setPositionByOrigin(topPoint, 'center', 'center')
  staticCanvas.add(invertPrint)
  staticCanvas.renderAll()

  return staticCanvas.toDataURL({ multiplier: 1, format: 'jpeg', quality: 1 })
}
